import { useEffect } from 'react';
import useApi from 'hooks/useApi';
import useCustomEvents from 'hooks/useCustomEvents';
import { useLoginState } from 'state/hooks/login.state.hook';

export const StoreTemplateErrorHandler = () => {
  const API = useApi({});
  const customEvents = useCustomEvents();
  const { logout } = useLoginState();

  useEffect(() => {
    if (API.getStoreTemplate.isError) {
      customEvents.resetSession();
      logout();
    }
  }, [API.getStoreTemplate.isError]);

  return null;
};
